import React,{ Component } from 'react';
import $ from 'jquery';
import {Link, browserHistory } from 'react-router';
import {Modal,Tab,Tabs,Breadcrumb,Button,Col,Popover,OverlayTrigger} from 'react-bootstrap';
import Swiper from 'react-id-swiper';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
import Icon, { FontAwesome, Feather } from 'react-web-vector-icons';
const parseHtml = require('html-react-parser');
import {connect} from 'react-redux';
import * as actions from '../../actions';
import { ccAvenue,razorpayForm } from "./../funtions/custom_functions.js";

const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets//';

class Web_Quick_Checkout extends Component{
	constructor(props){
		super(props);
		this.state={}
		this.state={
			page_loading:false,
			lod:false,
			user_address:[],
			edit_add_id:'',
			address_flag:0,
			add_address_form_status:false,
			add_available:false,
			add_address:false,
			edit_address:false,
			click_here_status: false,
			tot_data:this.props.total_cart_data,
			add_id:'',
			edit_data:[],
			// edit form elements 
			edit_name:'',
			edit_mobile:'',
			edit_state:'',
			edit_city:'',
			edit_doorno:'',
			edit_pincode:'',

			// add form elements
			add_name:localStorage.user_name,
			add_mobile:localStorage.user_mobile,
			add_state:'',
			add_city:'',
			add_doorno:'',
			add_pincode:'',

			//cart response 
			cart_count:0,
			grand_total:0,
			cart_add_id:'',
			coupon_code:0,
			aqua_cash:'',
			coupons_amt:'',
			ac_discount:'',

			//cart calculations response
			mode:'',
			pay_advance:'',
			complete_amount:'',
			pay_at_outlet:'',
			final_amt:'',
			totals:'',
			other_amount_field_status:false,
			ptype:'',
			min_val:'',
			max_val:'',
			err_qty_status:false,
			err_qty_msg:'',

			paymentMethodStatus:'',
			offline_payment:'',
			prebook_payment:'',
			fullamount_payment:'',
			otheramount_payment:'',

			// cart calculations respnose before pay now
			deal_id: 0,
			product_id:0,
			quantity:'',
			act_price:'',
			deal_price:'',
			total:'',
			total_discount:'',
			discount:'',
			pre_booking_amount:'',
			bank_fee:'',
			total_thx_fee:'',
			save_price:'',
			remaining_amount:'',
			payable_ad:'',
			payable_hatchery:'',
			ac_offer_title:'',
			aqua_cash_value:'',
			aqua_cash_code:'',
			ac_cal_info:'',
			pur_ern_ofr_code:'',
			pur_ern_ofr_title:'',
			pur_ern_ofr_desc:'',
			pur_ern_retrn_amt:'',
			full_aquacash_back_amount:'',
			full_aquacash_back_title:'',
			full_aquacash_back_code:'',
			full_aquacash_back_description:'',
			deal_type:'',
			promo_code:'',
			promo_amt:'',
			promo_title:'',
			promo_help:'',
			free_shipment:'',
			free_shipment_msg:'',
			user_details:[],
			coupon_amt:'',
			cart_ids:'',
			promodiscount:'',
			applied_promos:'',
			promos:[],
			ac_enough:'',
			ac_enough_msg:'',
			applied_coupons:'',

			//variable for storing the payment radio buttons 
			total_online_payment:'',
			default_ptype:'',
			mode_loading:false,
			amount_loading:false,
			evnt_key:2,

			// offline payment success displaying it in modal
			success_msg:'',
			thank_msg:'',

			offline_confirm_data:[],
			offline_pay_success_status:false,

			paying_process:false,

			// online payment response variables start
			pre_payment_id:'',
			order_id:'',
			//deal_type:'',
			//cart_ids:'',
			paid_amt:'',
			response:'',
			offline_success:false,
			// online payment response variables ends here

			cart_items:[],
			cart_total:'',
			gateway_mode: '',
			pageId:'.web_quick_checkout_page',
			order_error_modal: false,
			order_error_message: '',
			coupons: [],												
		}
		this.testclose=this.testclose.bind(this);

		this.getUserAddress=this.getUserAddress.bind(this);
		this.close=this.close.bind(this);
		this.handleSubmit_add=this.handleSubmit_add.bind(this);
		this.editAddress=this.editAddress.bind(this);
		this.deleteAddress=this.deleteAddress.bind(this);
		this.handleSubmit_edit=this.handleSubmit_edit.bind(this);
		this.getAddressDetails=this.getAddressDetails.bind(this);

		// functions for edit address form
		this.edit_nameChange=this.edit_nameChange.bind(this);
		this.edit_mobileChange=this.edit_mobileChange.bind(this);
		this.edit_stateChange=this.edit_stateChange.bind(this);
		this.edit_cityChange=this.edit_cityChange.bind(this);
		this.edit_doornoChange=this.edit_doornoChange.bind(this);
		this.edit_pincodeChange=this.edit_pincodeChange.bind(this);

		// functions for add address form
		this.add_nameChange=this.add_nameChange.bind(this);
		this.add_mobileChange=this.add_mobileChange.bind(this);
		this.add_stateChange=this.add_stateChange.bind(this);
		this.add_cityChange=this.add_cityChange.bind(this);
		this.add_doornoChange=this.add_doornoChange.bind(this);
		this.add_pincodeChange=this.add_pincodeChange.bind(this);
		//this.setDefaultAddress=this.setDefaultAddress.bind(this);

		this.getCart=this.getCart.bind(this);
		this.getCartCalculations=this.getCartCalculations.bind(this);
		this.validateOtherAmount=this.validateOtherAmount.bind(this);

		this.modeChange_cartCalculations=this.modeChange_cartCalculations.bind(this);
		this.handleTabsSelect=this.handleTabsSelect.bind(this);
		this.payNow=this.payNow.bind(this);
		this.ccAvenue=this.ccAvenue.bind(this);

		this.other_amount_cartCalculations=this.other_amount_cartCalculations.bind(this);
	    this.goNext =this.goNext.bind(this);
	    this.goPrev =this.goPrev.bind(this);
	}
	goNext()
	{
	    if(this.swiper) this.swiper.slideNext()
	}
	goPrev()
	{
    	if(this.swiper) this.swiper.slidePrev()
  	}
	componentDidMount()
	{
		window.scrollTo(0, 0);
		this.props.get_rzp_keys("desktop_web");
		localStorage.removeItem('w_r_s_dt');
	    localStorage.removeItem('w_r_e_coupon_dt');
	    localStorage.removeItem('w_r_e_s_dt');
	    localStorage.removeItem('web_mycart');
	    localStorage.removeItem('w_r_enq_seller_page');
	    localStorage.removeItem('w_r_p_dt');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('web_ofr_page');
	    localStorage.removeItem('profile');
	    localStorage.removeItem('myaquacash');
	    localStorage.removeItem('web_share_earn');
	   
	    localStorage.removeItem('order_details');
	    localStorage.removeItem('myorders');
	    localStorage.removeItem('w_r_p_deals');
	    localStorage.removeItem('seed');
	    localStorage.removeItem('nauplii');
	    localStorage.removeItem('subdeals');
	    localStorage.removeItem('shipping');
	    localStorage.removeItem('notifications');
	    localStorage.removeItem('web_quickcart');
	    localStorage.removeItem('view_rating');
	    localStorage.removeItem('w_modal_seed');
	    localStorage.removeItem('w_r_seed_deals');
	    localStorage.removeItem('w_r_e_p_dt');
	    localStorage.removeItem('w_modal_details');
	    localStorage.removeItem('offers');
	    localStorage.removeItem('give_rating');
	    localStorage.removeItem('pprice');
	    localStorage.removeItem('sprice');
	    localStorage.removeItem('seed_id');
	    localStorage.removeItem('h_type');
	    localStorage.removeItem('web_pro_ofr_dtls');
	    localStorage.removeItem('web_wishlist');
	    localStorage.removeItem('web_brand_details');

	    localStorage.removeItem('m_r_s_dt');
	    localStorage.removeItem('m_r_e_coupon_dt');
	    localStorage.removeItem('m_r_e_s_dt');
	    localStorage.removeItem('mob_mycart');
	    localStorage.removeItem('m_r_enq_seller_page');
	    localStorage.removeItem('m_r_p_dt');
	    localStorage.removeItem('m_r_e_p_dt');
	    localStorage.removeItem('ofr_page');
	    localStorage.removeItem('pro_ofr_dtls');

	    localStorage.removeItem('share_earn');
	    localStorage.removeItem('my_orders');
	    localStorage.removeItem('m_r_p_deals');
	    localStorage.removeItem('mob_quickcart');
	    localStorage.removeItem('partner_deals');
		if(screen.width < 800)
		{
			window.location.href="/quick_checkout";
		}
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('checkout','/web/quick_checkout');
			browserHistory.push('/web/login');
		}
		else
		{
			this.getUserAddress();	
		}
		// this.getCart();
	}
	testclose()
	{
		this.setState({
			offline_pay_success_status:false,
		});
	}
	ccAvenue()
	{
		var username=this.state.user_details.username;
		var email=this.state.user_details.email;
		var mobile=this.state.user_details.mobile;
		var address=this.state.user_details.address;
		var city=this.state.user_details.city;
		var pincode=this.state.user_details.pincode;
		var state=this.state.user_details.state;
		// var behalf_of=this.state.user_details.behalf_of;
		var deal_type=this.state.deal_type;
		var add_id=this.state.cart_add_id;
		
		var basePayUrl='https://aqua.deals/paymentGateWay/paymentRequestHandler.php';
		// var basePayUrl='http://203.193.173.125/paymentGateWay/paymentRequestHandler.php';
		
		var data1={access_code:'AVIJ67DJ41BD20JIDB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:add_id,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',redirect_url:'https://aqua.deals/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
		// var data1={access_code:'AVJZ66DG16BM17ZJMB',merchant_id:'103328',order_id:this.state.order_id,merchant_param1:this.state.pre_payment_id,merchant_param2:deal_type,merchant_param3:add_id,merchant_param4:'desktop_web',amount:this.state.paid_amt,currency:'INR',cancel_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',redirect_url:'http://203.193.173.125/paymentGateWay/paymentResponseHandler.php',billing_name:username,billing_address:address,billing_city:city,billing_state:state,billing_zip:pincode,billing_tel:mobile,billing_country:'India',billing_email:email};
		$.ajax({
			method:'POST',
			data:data1,
			url:basePayUrl,
			success:function(data)
			{
				$('.web_quick_checkout_page').html(data);
			},
			error:function(err)
			{
				console.log(err);
			}

		});
	}
	//payNow function is used to submit the values to 
	payNow()
	{
		if(this.state.add_address_form_status)
		{
			this.setState({
				add_address:true,
			});
		}
		else
		{
			this.setState({
				paying_process:true,
			});

			// here this.state.ptype = mode of the payment 
			// 1:offline, 2:pay advance, 3:online pay total , 4: online pay other amount
			if(this.state.ptype===1)
			{
				var baseUrl='https://aquadeals.in/admin/web3/user/';
				var data1={from:'desktop_web',uid:localStorage.user_id,token:localStorage.token,product_id:this.state.product_id,quantity:this.state.quantity,act_price:this.state.act_price,deal_price:this.state.deal_price,total:this.state.total,total_discount:this.state.total_discount,discount:this.state.discount,total_online_payment:this.state.total_online_payment,pre_booking_amount:this.state.pre_booking_amount,bank_fee:this.state.bank_fee,total_thx_fee:this.state.total_thx_fee,save_price:this.state.save_price,remaining_amount:this.state.remaining_amount,payable_ad:this.state.payable_ad,payable_hatchery:this.state.payable_hatchery,mode:this.state.ptype,coupons_amt:this.state.coupons_amt,aqua_cash:this.state.aqua_cash,ac_offer_title:this.state.ac_offer_title,aqua_cash_value:this.state.aqua_cash_value,aqua_cash_code:this.state.aqua_cash_code,ac_cal_info:this.state.ac_cal_info,pur_ern_ofr_code:this.state.pur_ern_ofr_code,pur_ern_ofr_title:this.state.pur_ern_ofr_title,pur_ern_ofr_desc:this.state.pur_ern_ofr_desc,pur_ern_retrn_amt:this.state.pur_ern_retrn_amt,full_aquacash_back_amount:this.state.full_aquacash_back_amount,full_aquacash_back_title:this.state.full_aquacash_back_title,full_aquacash_back_code:this.state.full_aquacash_back_code,full_aquacash_back_description:this.state.full_aquacash_back_description,deal_type:this.state.deal_type,promo_code:this.state.promo_code,promo_amt:this.state.promo_amt,promo_title:this.state.promo_title,promo_help:this.state.promo_help,free_shipment:this.state.free_shipment,free_shipment_msg:this.state.free_shipment_msg,paymentMethodStatus:this.state.paymentMethodStatus,add_id:this.state.cart_add_id,complete_amount:this.state.complete_amount,pay_advance:this.state.pay_advance,pay_at_outlet:this.state.pay_at_outlet,final_amt:this.state.final_amt,totals:this.state.totals,coupon_code:this.state.coupon_code,coupon_amt:this.state.coupon_amt,cart_ids:this.state.cart_ids,applied_coupons:this.state.applied_coupons,promodiscount:this.state.promodiscount,applied_promos:this.state.applied_promos,quick_buy:1};
				var data2=JSON.stringify(data1);
				$.ajax({
					method:'POST',
					dataType:'json',
					data:{req:data2},
					url:baseUrl+'bookCart',
					success:function(data)
					{
						if(data.status==="success")
						{
							this.setState({
								offline_confirm_data:data,
								offline_pay_success_status:true,
								paying_process:false,
								offline_success:true,
							});
							$('#off_modal_status').parent().addClass('offline_modal');
						}
					}.bind(this),
					error:function(err)
					{

					}
				});	
			}
			else if(this.state.ptype===3 || this.state.ptype===2)
			{
				baseUrl='https://aquadeals.in/admin/web3/user/';
				data1={from:'desktop_web',uid:localStorage.user_id,token:localStorage.token,product_id:this.state.product_id,quantity:this.state.quantity,act_price:this.state.act_price,deal_price:this.state.deal_price,total:this.state.total,total_discount:this.state.total_discount,discount:this.state.discount,total_online_payment:this.state.total_online_payment,pre_booking_amount:this.state.pre_booking_amount,bank_fee:this.state.bank_fee,total_thx_fee:this.state.total_thx_fee,save_price:this.state.save_price,remaining_amount:this.state.remaining_amount,payable_ad:this.state.payable_ad,payable_hatchery:this.state.payable_hatchery,mode:this.state.ptype,aqua_cash:this.state.aqua_cash,ac_offer_title:this.state.ac_offer_title,aqua_cash_value:this.state.aqua_cash_value,aqua_cash_code:this.state.aqua_cash_code,ac_cal_info:this.state.ac_cal_info,pur_ern_ofr_code:this.state.pur_ern_ofr_code,pur_ern_ofr_title:this.state.pur_ern_ofr_title,pur_ern_ofr_desc:this.state.pur_ern_ofr_desc,pur_ern_retrn_amt:this.state.pur_ern_retrn_amt,full_aquacash_back_title:this.state.full_aquacash_back_title,full_aquacash_back_code:this.state.full_aquacash_back_code,full_aquacash_back_description:this.state.full_aquacash_back_description,full_aquacash_back_amount:this.state.full_aquacash_back_amount,deal_type:this.state.deal_type,promo_code:this.state.promo_code,promo_amt:this.state.promo_amt,promo_title:this.state.promo_title,promo_help:this.state.promo_help,free_shipment:this.state.free_shipment,free_shipment_msg:this.state.free_shipment_msg,paymentMethodStatus:this.state.paymentMethodStatus,add_id:this.state.cart_add_id,complete_amount:this.state.complete_amount,pay_advance:this.state.pay_advance,pay_at_outlet:this.state.pay_at_outlet,final_amt:this.state.final_amt,totals:this.state.totals,coupon_code:this.state.coupon_code,coupon_amt:this.state.coupon_amt,cart_ids:this.state.cart_ids,applied_coupons:this.state.applied_coupons,coupons_amt:this.state.coupons_amt,promodiscount:this.state.promodiscount,applied_promos:this.state.applied_promos,quick_buy:1};
					data2=JSON.stringify(data1);
					$.ajax({
						method:'POST',
						dataType:'json',
						data:{req:data2},
						url:baseUrl+'onlineCartProcessing',
						success:function(data)
						{
							if(data.status==="success")
							{
								this.setState({
									pre_payment_id:data.pre_payment_id,
									order_id:data.order_id,
									deal_type:data.deal_type,
									cart_ids:data.cart_ids,
									paid_amt:data.paid_amt,
								});
								//this.ccAvenue();
								//this.ccAvenue();
								var payment_params= {from:'desktop_web',
								uid:localStorage.getItem('user_id'),
								pre_payment_id:data.pre_payment_id,
								order_id:data.order_id,
								deal_type:data.deal_type,
								cart_ids:data.cart_ids,
								paid_amt:data.paid_amt,
								username: this.state.user_details.username,
								address:this.state.user_details.address,
								city:this.state.user_details.city,
								state:this.state.user_details.state,
								pincode:this.state.user_details.pincode,
								mobile:this.state.user_details.mobile,
								country:'India',
								email:this.state.user_details.email,
								cart_add_id:this.state.cart_add_id,
								pageId:this.state.pageId,
								rzp_key:this.props.rzp_keys.key_id};				
									if(this.state.gateway_mode == 2){										
									this.props.get_rzp_keys("desktop_web");
									razorpayForm(payment_params);
									this.setState({
										paying_process:false,
									});					
									}else{
									ccAvenue(payment_params);					
									}
   							}								
				   			if(data.status==="invalid"){
				   				this.setState({
				   					order_error_modal:true,
				   					order_error_message:data.message,
				   				});
				   				setTimeout(function(){ browserHistory.push('/web/home');}, 3000);				   				
				   			}							

						}.bind(this),
						error:function(err)
						{
							console.log(err);
						}
					});
			}
			else if(this.state.ptype===4)
			{
				var x='';
				if(this.refs.ref_other_amt.value==="")
				{
					x='* Enter Amount';
					this.setState({
						err_qty_msg:'* Enter Amount',
						err_qty_status:true,
					});
				}
				if(parseInt(this.refs.ref_other_amt.value,10) < parseInt(this.state.min_val,10))
				{
					x='Minimum Quantity is '+this.state.min_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg:'* Minimum amount is '+this.state.min_val,
					});
				}
				if(this.refs.ref_other_amt==='')
				{
					x='Minimum Quantity is '+this.state.min_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg:'* Minimum amount is '+this.state.min_val,
					});
				}
				if(parseInt(this.refs.ref_other_amt.value,10) > parseInt(this.state.max_val,10))
				{
					// alert('Maximum Quantity is '+this.state.max_qty);
					x='Maximum Quantity is '+this.state.max_val;
					this.setState({
						err_qty_status: true,
						err_qty_msg:'* Maximum amount is '+this.state.max_val,
					});
				}
				const check= /[^0-9]/gi;
				if(check.test(this.refs.ref_other_amt.value))
				{
					x='* Invalid Amount';	
					this.setState({
						err_qty_status: true,
						err_qty_msg:'* Invalid Amount',
					});
				}

				if(x==='')
				{
					baseUrl='https://aquadeals.in/admin/web3/user/';
					data1={from:'desktop_web',uid:localStorage.user_id,token:localStorage.token,product_id:this.state.product_id,quantity:this.state.quantity,act_price:this.state.act_price,deal_price:this.state.deal_price,total:this.state.total,total_discount:this.state.total_discount,discount:this.state.discount,total_online_payment:this.state.total_online_payment,pre_booking_amount:this.state.pre_booking_amount,bank_fee:this.state.bank_fee,total_thx_fee:this.state.total_thx_fee,save_price:this.state.save_price,remaining_amount:this.state.remaining_amount,payable_ad:this.state.payable_ad,payable_hatchery:this.state.payable_hatchery,mode:this.state.ptype,aqua_cash:this.state.aqua_cash,ac_offer_title:this.state.ac_offer_title,aqua_cash_value:this.state.aqua_cash_value,aqua_cash_code:this.state.aqua_cash_code,ac_cal_info:this.state.ac_cal_info,pur_ern_ofr_code:this.state.pur_ern_ofr_code,pur_ern_ofr_title:this.state.pur_ern_ofr_title,pur_ern_ofr_desc:this.state.pur_ern_ofr_desc,pur_ern_retrn_amt:this.state.pur_ern_retrn_amt,full_aquacash_back_title:this.state.full_aquacash_back_title,full_aquacash_back_code:this.state.full_aquacash_back_code,full_aquacash_back_description:this.state.full_aquacash_back_description,full_aquacash_back_amount:this.state.full_aquacash_back_amount,deal_type:this.state.deal_type,promo_code:this.state.promo_code,promo_amt:this.state.promo_amt,promo_title:this.state.promo_title,promo_help:this.state.promo_help,free_shipment:this.state.free_shipment,free_shipment_msg:this.state.free_shipment_msg,paymentMethodStatus:this.state.paymentMethodStatus,add_id:this.state.cart_add_id,complete_amount:this.state.complete_amount,pay_advance:this.state.pay_advance,pay_at_outlet:this.state.pay_at_outlet,final_amt:this.state.final_amt,totals:this.state.totals,coupon_code:this.state.coupon_code,coupon_amt:this.state.coupon_amt,cart_ids:this.state.cart_ids,applied_coupons:this.state.applied_coupons,coupons_amt:this.state.coupons_amt,promodiscount:this.state.promodiscount,applied_promos:this.state.applied_promos,quick_buy:1};
					data2=JSON.stringify(data1);
					$.ajax({
						method:'POST',
						dataType:'json',
						data:{req:data2},
						url:baseUrl+'onlineCartProcessing',
						success:function(data)
						{
							if(data.status==="success")
							{
								this.setState({
									pre_payment_id:data.pre_payment_id,
									order_id:data.order_id,
									deal_type:data.deal_type,
									cart_ids:data.cart_ids,
									paid_amt:data.paid_amt,
								});
								//this.ccAvenue();
										var payment_params= {from:'desktop_web',
														 uid:localStorage.getItem('user_id'),
														 pre_payment_id:data.pre_payment_id,
														 order_id:data.order_id,
														 deal_type:data.deal_type,
														 cart_ids:data.cart_ids,
														 paid_amt:data.paid_amt,
														 username: this.state.user_details.username,
														 address:this.state.user_details.address,
														 city:this.state.user_details.city,
														 state:this.state.user_details.state,
														 pincode:this.state.user_details.pincode,
														 mobile:this.state.user_details.mobile,
														 country:'India',
														 email:this.state.user_details.email,
														 cart_add_id:this.state.cart_add_id,
														 pageId:this.state.pageId,
														 rzp_key:this.props.rzp_keys.key_id};								
									if(this.state.gateway_mode == 2){										
										razorpayForm(payment_params);
													this.setState({paying_process:false});										
									}else{											
										ccAvenue(payment_params);
									}
									if(data.status==='error' && data.message==='Token mismatch')
									{
										this.props.tokenCheck();
									}
						   			if(data.status==="invalid"){
						   				this.setState({
						   					order_error_modal:true,
						   					order_error_message:data.message,
						   				});
						   				setTimeout(function(){ browserHistory.push('/web/home');}, 3000);				   				
						   			}										
							}


						}.bind(this),
						error:function(err)
						{
							console.log(err);
						}
					});
				}
				else
				{
					// alert('error');
				}
				this.setState({
					paying_process:false,
				});
			}
		}
	}
	// getUserAddress function is used to get the address of the user when page loads. 
	getUserAddress()
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from: 'desktop_web',id:localStorage.user_id,token:localStorage.token,quick_buy:1};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'getuserAddress',
			success:function(data)
			{
				if(data.status==="success" && data.address.length > 0)
				{
					this.setState({
						user_address:data.address,
						address_flag:data.address_flag,
						add_available:true,
						click_here_status:false,
						add_address_form_status:false,
					});
				}
				else if(data.status==="success" && data.address.length ===0)
				{
					this.setState({
						user_address:data.address,
						click_here_status:true,
						address_flag:data.address_flag,
						add_address_form_status:true,
					});
				}
			}.bind(this),
			error:function(err)
			{
				console.log(err);
			}
		});
		this.getCart();
		setTimeout(() => {this.setState({lod: true}); }, 8000);
	}
	//getCart function is used to get the cart values from the cart page to get the cart values to the checkout page
	getCart()
	{
		var apply_coupon=localStorage.getItem('apply_coupon');
		var apply_coupon_code=localStorage.getItem('apply_coupon_code');

		var baseUrl='https://aquadeals.in/admin/web3/user/';
      	var data1= {from:'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token'),apply_ac:1,apply_coupon:apply_coupon,apply_coupon_code:apply_coupon_code,quick_buy:1};
      	var data2= JSON.stringify(data1);
		$.ajax({
      		method:'POST',
      		dataType:'json',
      		data:{req:data2},
      		url:baseUrl+'cart',
      		success:function(data)
      		{
      			this.setState({
      				total:data.total,
      				cart_count:data.cart_count,
      				//add_id:data.add_id,
      				ac_discount:data.ac_discount,
      				grand_total:data.grand_total,
      				aqua_cash:data.aqua_cash,
      				ac_enough:data.ac_enough,
      				ac_enough_msg:data.ac_enough_msg,
      				apply_ac:data.apply_ac,
      				used_cash:data.used_cash,
      				used_cash1:data.used_cash1,
      				coupons:data.coupons,
      				applied_coupons:data.applied_coupons,
      				applied_coupons1:data.applied_coupons1,
      				coupons_amt:data.coupons_amt,
					coupons_amt1:data.coupons_amt1,
					proceedCheck:data.proceedCheck,
					proceedMsg:data.proceedMsg,
					promodiscount:data.promodiscount,
					promos:data.promos,
					applied_promos:data.applied_promos,
					loc_msg:data.loc_msg,
					address_change:data.address_change,
					address:data.address,
					location:data.location,
					zip:data.zip,
					state:data.state,
					city:data.city,
					cart_add_id:data.add_id,

					cart_items:data.items,
      			    cart_total:data.total,
      			});
      			this.getCartCalculations();
      		}.bind(this),
      		error:function(err)
      		{

      		}
      	});
	}
	//getCartCalculations function is used to get the results of the cart and payment types resutls.
	getCartCalculations()
	{
		this.setState({
			mode_loading:true,
			amount_loading:true,
		});
		var uid=0;
		var token=0;
		var coupon_code=0;
		var coupon_amount=0;
		if(localStorage.user_id)
		{
			uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(localStorage.token)
		{
			token=localStorage.getItem('token');
		}
		else
		{
			token=0;
		}
		if(localStorage.apply_coupon_code)
		{
			coupon_code=localStorage.getItem('apply_coupon_code');
		}
		else
		{
			coupon_code=0;
		}
		if(localStorage.apply_coupon)
		{
			coupon_amount=localStorage.getItem('apply_coupon');
		}
		else
		{
			coupon_amount=0;
		}
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',uid:uid,token:token,mode:2,add_id:this.state.cart_add_id,code:coupon_code,coupon_amount:coupon_amount,other_amount:'',aqua_cash:this.state.used_cash1,coupons_amt:this.state.coupons_amt,ac_discount:this.state.ac_discount,promodiscount:this.state.promodiscount,applied_promos:this.state.applied_promos,quick_buy:1};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'cartCalculations',
			success:function(data)
			{	
				if(data.status==="success")
				{
					this.setState({
						mode_loading:false,
						page_loading:true,
						amount_loading:false,
						mode:data.mode,
						ptype:data.mode,
						default_ptype:data.mode,
						final_amt:data.final_amt,
						pay_at_outlet:data.pay_at_outlet,
						pay_advance:data.pay_advance,
						complete_amount:data.complete_amount,
						min_val:data.min_val,
						max_val:data.max_val,

						paymentMethodStatus:data.paymentMethodStatus,
						offline_payment:data.offline_payment,
						prebook_payment:data.prebook_payment,
						fullamount_payment:data.fullamount_payment,
						otheramount_payment:data.otheramount_payment,

						total_online_payment:data.total_online_payment,

						product_id:data.product_id,
						quantity:data.quantity,
						act_price:data.act_price,
						deal_price:data.deal_price,
						total:data.total,
						total_discount:data.total_discount,
						discount:data.discount,
						pre_booking_amount:data.pre_booking_amount,
						bank_fee:data.bank_fee,
						total_thx_fee:data.total_thx_fee,
						save_price:data.save_price,
						remaining_amount:data.remaining_amount,
						payable_ad:data.payable_ad,
						payable_hatchery:data.payable_hatchery,
						aqua_cash:data.aqua_cash,
						ac_offer_title:data.ac_offer_title,
						aqua_cash_value:data.aqua_cash_value,
						aqua_cash_code:data.aqua_cash_code,
						ac_cal_info:data.ac_cal_info,
						pur_ern_ofr_code:data.pur_ern_ofr_code,
						pur_ern_ofr_title:data.pur_ern_ofr_title,
						pur_ern_ofr_desc:data.pur_ern_ofr_desc,
						pur_ern_retrn_amt:data.pur_ern_retrn_amt,
						full_aquacash_back_title:data.full_aquacash_back_title,
						full_aquacash_back_code:data.full_aquacash_back_code,
						full_aquacash_back_description:data.full_aquacash_back_description,
						full_aquacash_back_amount:data.full_aquacash_back_amount,
						deal_type:data.deal_type,
						promo_code:data.promo_code,
						promo_amt:data.promo_amt,
						promo_title:data.promo_title,
						promo_help:data.promo_help,
						free_shipment:data.free_shipment,
						free_shipment_msg:data.free_shipment_msg,
						coupon_code:data.coupon_code,
						coupon_amt:data.coupon_amt,
						cart_ids:data.cart_ids,
						coupons_amt:data.coupons_amt,
						promodiscount:data.promodiscount,
						applied_promos:data.applied_promos,

						user_details:data.user_details,
						cart_add_id:data.add_id,
						gateway_mode:data.gateway_mode,
						deliver_date_text: data.deliver_date_text,
						payment_options: data.payment_options						
					});
					if(data.mode !==1)
					{
						this.setState({
							evnt_key:2,
						});
					}
				}
			}.bind(this),
			error:function(err)
			{
				this.setState({
					page_loading:false,
					lod:true,
				})
			}.bind(this)
		});
	}
	other_amount_cartCalculations(mode,other_amount)
	{
		this.setState({
			amount_loading:true,
		});
		var uid=0;
		var token=0;
		var coupon_code=0;
		var coupon_amount=0;
		
		if(localStorage.user_id)
		{
			uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(localStorage.token)
		{
			token=localStorage.getItem('token');
		}
		else
		{
			token=0;
		}
		if(localStorage.apply_coupon_code)
		{
			coupon_code=localStorage.getItem('apply_coupon_code');
		}
		else
		{
			coupon_code=0;
		}
		if(localStorage.apply_coupon)
		{
			coupon_amount=localStorage.getItem('apply_coupon');
		}
		else
		{
			coupon_amount=0;
		}

		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',uid:uid,token:token,mode:4,add_id:this.state.cart_add_id,code:coupon_code,coupon_amount:coupon_amount,other_amount:other_amount,aqua_cash:this.state.used_cash1,coupons_amt:this.state.coupons_amt,ac_discount:this.state.ac_discount,promodiscount:this.state.promodiscount,applied_promos:this.state.applied_promos,quick_buy:1};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'cartCalculations',
			success:function(data)
			{	
				if(data.status==="success")
				{
					this.setState({
						// mode_loading:false,
						amount_loading:false,
						mode:data.mode,
						ptype:data.mode,
						final_amt:data.final_amt,
						pay_at_outlet:data.pay_at_outlet,
						pay_advance:data.pay_advance,
						complete_amount:data.complete_amount,
						min_val:data.min_val,
						max_val:data.max_val,

						paymentMethodStatus:data.paymentMethodStatus,
						offline_payment:data.offline_payment,
						prebook_payment:data.prebook_payment,
						fullamount_payment:data.fullamount_payment,
						otheramount_payment:data.otheramount_payment,
						total_online_payment:data.total_online_payment,
						product_id:data.product_id,
						quantity:data.quantity,
						act_price:data.act_price,
						deal_price:data.deal_price,
						total:data.total,
						total_discount:data.total_discount,
						discount:data.discount,
						pre_booking_amount:data.pre_booking_amount,
						bank_fee:data.bank_fee,
						total_thx_fee:data.total_thx_fee,
						save_price:data.save_price,
						remaining_amount:data.remaining_amount,
						payable_ad:data.payable_ad,
						payable_hatchery:data.payable_hatchery,
						aqua_cash:data.aqua_cash,
						ac_offer_title:data.ac_offer_title,
						aqua_cash_value:data.aqua_cash_value,
						aqua_cash_code:data.aqua_cash_code,
						ac_cal_info:data.ac_cal_info,
						pur_ern_ofr_code:data.pur_ern_ofr_code,
						pur_ern_ofr_title:data.pur_ern_ofr_title,
						pur_ern_ofr_desc:data.pur_ern_ofr_desc,
						pur_ern_retrn_amt:data.pur_ern_retrn_amt,
						full_aquacash_back_title:data.full_aquacash_back_title,
						full_aquacash_back_code:data.full_aquacash_back_code,
						full_aquacash_back_description:data.full_aquacash_back_description,
						full_aquacash_back_amount:data.full_aquacash_back_amount,
						deal_type:data.deal_type,
						promo_code:data.promo_code,
						promo_amt:data.promo_amt,
						promo_title:data.promo_title,
						promo_help:data.promo_help,
						free_shipment:data.free_shipment,
						free_shipment_msg:data.free_shipment_msg,
						coupon_code:data.coupon_code,
						coupon_amt:data.coupon_amt,
						cart_ids:data.cart_ids,
						coupons_amt:data.coupons_amt,
						promodiscount:data.promodiscount,
						applied_promos:data.applied_promos,

						user_details:data.user_details,
						cart_add_id:data.add_id,
						gateway_mode:data.gateway_mode,	
						deliver_date_text: data.deliver_date_text,
						payment_options: data.payment_options,
					});
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	modeChange_cartCalculations(mode)
	{
		this.setState({
			mode_loading:true,
			amount_loading:true,
		})
		var uid=0;
		var token=0;
		var coupon_code=0;
		var coupon_amount=0;
		
		if(localStorage.user_id)
		{
			uid=localStorage.getItem('user_id');
		}
		else
		{
			uid=0;
		}
		if(localStorage.token)
		{
			token=localStorage.getItem('token');
		}
		else
		{
			token=0;
		}
		if(localStorage.apply_coupon_code)
		{
			coupon_code=localStorage.getItem('apply_coupon_code');
		}
		else
		{
			coupon_code=0;
		}
		if(localStorage.apply_coupon)
		{
			coupon_amount=localStorage.getItem('apply_coupon');
		}
		else
		{
			coupon_amount=0;
		}

		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',uid:uid,token:token,mode:mode,add_id:this.state.cart_add_id,code:coupon_code,coupon_amount:coupon_amount,other_amount:'',aqua_cash:this.state.used_cash1,coupons_amt:this.state.coupons_amt,ac_discount:this.state.ac_discount,promodiscount:this.state.promodiscount,applied_promos:this.state.applied_promos,quick_buy:1};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'cartCalculations',
			success:function(data)
			{	
				if(data.status==="success")
				{
					this.setState({
						mode_loading:false,
						amount_loading:false,
						mode:data.mode,
						ptype:data.mode,
						final_amt:data.final_amt,
						pay_at_outlet:data.pay_at_outlet,
						pay_advance:data.pay_advance,
						complete_amount:data.complete_amount,
						min_val:data.min_val,
						max_val:data.max_val,

						paymentMethodStatus:data.paymentMethodStatus,
						offline_payment:data.offline_payment,
						prebook_payment:data.prebook_payment,
						fullamount_payment:data.fullamount_payment,
						otheramount_payment:data.otheramount_payment,
						total_online_payment:data.total_online_payment,
						product_id:data.product_id,
						quantity:data.quantity,
						act_price:data.act_price,
						deal_price:data.deal_price,
						total:data.total,
						total_discount:data.total_discount,
						discount:data.discount,
						pre_booking_amount:data.pre_booking_amount,
						bank_fee:data.bank_fee,
						total_thx_fee:data.total_thx_fee,
						save_price:data.save_price,
						remaining_amount:data.remaining_amount,
						payable_ad:data.payable_ad,
						payable_hatchery:data.payable_hatchery,
						aqua_cash:data.aqua_cash,
						ac_offer_title:data.ac_offer_title,
						aqua_cash_value:data.aqua_cash_value,
						aqua_cash_code:data.aqua_cash_code,
						ac_cal_info:data.ac_cal_info,
						pur_ern_ofr_code:data.pur_ern_ofr_code,
						pur_ern_ofr_title:data.pur_ern_ofr_title,
						pur_ern_ofr_desc:data.pur_ern_ofr_desc,
						pur_ern_retrn_amt:data.pur_ern_retrn_amt,
						full_aquacash_back_title:data.full_aquacash_back_title,
						full_aquacash_back_code:data.full_aquacash_back_code,
						full_aquacash_back_description:data.full_aquacash_back_description,
						full_aquacash_back_amount:data.full_aquacash_back_amount,
						deal_type:data.deal_type,
						promo_code:data.promo_code,
						promo_amt:data.promo_amt,
						promo_title:data.promo_title,
						promo_help:data.promo_help,
						free_shipment:data.free_shipment,
						free_shipment_msg:data.free_shipment_msg,
						coupon_code:data.coupon_code,
						coupon_amt:data.coupon_amt,
						cart_ids:data.cart_ids,
						coupons_amt:data.coupons_amt,
						promodiscount:data.promodiscount,
						applied_promos:data.applied_promos,

						user_details:data.user_details,
						cart_add_id:data.add_id,
					});
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	// close function is used to close both edit address modal & add address modal boxes.
	close()
	{
		this.setState({
			add_address:false,
			edit_address:false,
		});
	}
	// handleSubmit_add function for submitting the new address when click on add new address 
	handleSubmit_add(event)
	{
		event.preventDefault();
		var name=this.refs.add_name.value;
		var mobile=this.refs.add_mobile.value;
		var state=this.refs.add_state.value;
		var city=this.refs.add_city.value;
		var doorno=this.refs.add_doorno.value;
		var pincode=this.refs.add_pincode.value;

		var flag=0;  
		const namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
	    if(name && !namePattern.test(name))
	    {
	     	$('#add_name_err').text('*name is minimum 3 characters');
	      	flag = 1;
	    }
	    if(mobile.length < 10)
	    {
	    	$('#add_mobile_err').text('*enter valid number');
	      	flag = 1;    
	    }
	    if(state && !namePattern.test(state) && state.length < 2)
	    {
	      	$('#add_state_err').text('*enter state');
	      	flag= 1;
	    }
	    if(city && !namePattern.test(city))
	    {
	      	$('#add_city_err').text('*enter city');
	      	flag= 1;
	    }
	    if(doorno && doorno.length <= 1)
	    {
	    	$('#add_doorno_err').text('*enter address');
	      	flag= 1;
	    }
		if(pincode && pincode.length < 6)
	    {
	    	$('#add_pincode_err').text('*enter valid pincode');
	    	flag= 1;
	    }
		if(flag===0)
	    {
			var baseUrl='https://aquadeals.in/admin/web3/user/';
			var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,name:name,mobile:mobile,state:state,city:city,address:doorno,zip:pincode,quick_buy:1};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'saveAdd',
				success:function(data)
				{
					if(data.status==="success")
					{
						this.close();
						this.getUserAddress();
						this.setState({
							add_state:'',
							add_city:'',
							add_doorno:'',
							add_pincode:'',
						});
					}
					if(data.status==='error' && data.message==='Token mismatch')
					{
						this.props.tokenCheck();
					}
				}.bind(this),
				error:function(err)
				{

				}
			});
		}
	}
	//handleSubmit_edit function for updating the address when click on edit icon in the swipe list.
	handleSubmit_edit(event)
	{
		event.preventDefault();
		var add_id=this.state.edit_add_id;

		var name=this.refs.edit_name.value;
		var mobile=this.refs.edit_mobile.value;
		var state=this.refs.edit_state.value;
		var city=this.refs.edit_city.value;
		var doorno=this.refs.edit_doorno.value;
		var pincode=this.refs.edit_pincode.value;

		var flag=0;  
	    // const emailPattern = /(.+)@(.+){2,}\.(.+){2,}/;
	    const namePattern = /^([a-zA-Z0-9_-])\w.{1,}$/;
	    if(name && !namePattern.test(name))
	    {
	      	$('#edit_name_err').text('*name is minimum 3 characters');
	      	flag = 1;
	    }
	    if(mobile.length < 10)
	    {
	    	$('#edit_mobile_err').text('*enter valid number');
	      	flag = 1;    
	    }
	    if(state && !namePattern.test(state) && state.length < 2)
	    {
	      	$('#edit_state_err').text('*enter state');
	      	flag= 1;
	    }
	    if(city && !namePattern.test(city))
	    {
	      	$('#edit_city_err').text('*enter city');
	      	flag= 1;
	    }
	    if(doorno && doorno.length <= 1)
	    {
	    	$('#edit_doorno_err').text('*enter address');
	      	flag= 1;
	    }
		if(pincode && pincode.length < 6)
	    {
	    	$('#edit_pincode_err').text('*enter valid pincode');
	    	flag= 1;
	    }
	    if(flag===0)
	    {
	    	var baseUrl='https://aquadeals.in/admin/web3/user/';
			var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,add_id:add_id,name:name,mobile:mobile,state:state,city:city,address:doorno,zip:pincode,quick_buy:1};
			var data2=JSON.stringify(data1);
			$.ajax({
				method:'POST',
				dataType:'json',
				data:{req:data2},
				url:baseUrl+'updateAdd',
				success:function(data)
				{
					if(data.status==="success")
					{
						this.close();
						this.getUserAddress();
					}
					if(data.status==='error' && data.message==='Token mismatch')
					{
						this.props.tokenCheck();
					}
				}.bind(this),
				error:function(err)
				{

				}
			});
		}
	}
	//editAddress function for when click on edit icon that enables the status of the Edit form modal
	editAddress(add_id)
	{
		this.setState({
			edit_add_id:add_id,
			edit_address:true,
		});
	}
	// deleteAddress function is used when click on deleted icon in swipe address list
	deleteAddress(add_id)
	{
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,add_id:add_id,quick_buy:1};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'deleteAdd',
			success:function(data)
			{
				if(data.status==="success")
				{
					this.getUserAddress();
				}
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	// getAddressDetails function is used to get the address details from server when click the edit icon and edit modal form is opened. 
	getAddressDetails()
	{
		var add_id=this.state.edit_add_id;
		var baseUrl='https://aquadeals.in/admin/web3/user/';
		var data1={from:'desktop_web',uid:localStorage.user_id,token:localStorage.token,id:add_id,quick_buy:1};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'POST',
			dataType:'json',
			data:{req:data2},
			url:baseUrl+'get_add_details',
			success:function(data)
			{
				if(data.status==="success")
				{
					this.setState({
						edit_data:data.data,
						edit_name:data.data[0]['name'],
						edit_mobile:data.data[0]['phone'],
						edit_state:data.data[0]['state'],
						edit_city:data.data[0]['city'],
						edit_doorno:data.data[0]['address'],
						edit_pincode:data.data[0]['zip'],
					});	
				}
				if(data.status==='error' && data.message==='Token mismatch')
				{
					this.props.tokenCheck();
				}
			}.bind(this),
			error:function(err)
			{

			}
		});
	}
	//******************
	/* functions for EDIT form validations and upations start here  */
	// edit_nameChange function is used to set the edit_name value edit modal form.
	edit_nameChange(event)
	{
		// this.setState({
		// 	edit_name:event.target.value,
		// });
		var x=event.target.value;
		var invalidChars = /[^a-zA-Z ]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        		edit_name:x,
		   });
	    }
	}
	edit_mobileChange(event)
	{
		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	edit_mobile: x,
	        });
	    }
	}
	edit_stateChange(event)
	{
		// this.setState({
		// 	edit_state:event.target.value,
		// });
		var x=event.target.value;
		var invalidChars = /[^a-zA-Z ]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        		edit_state:x,
		
	        });
	    }
	}
	edit_cityChange(event)
	{
		// this.setState({
		// 	edit_city:event.target.value,
		// });
		var x=event.target.value;
		var invalidChars = /[^a-zA-Z]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        		edit_city:x,
		    });
	    }
	}
	edit_doornoChange(event)
	{
		this.setState({
			edit_doorno:event.target.value,
		});
	}
	edit_pincodeChange(event)
	{
		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	edit_pincode: x,
	        });
	    }
		// this.setState({
		// 	edit_pincode:event.target.value,
		// });
	}
	// **********************************
	// functions for "EDIT" form validations and upations "ENDS" here

	// functions for "ADD" form validations and updations START here 
	// ***************************************
	add_nameChange(event)
	{
		// this.setState({
		// 	add_name:event.target.value,
		// });
		var x=event.target.value;
		var invalidChars = /[^a-zA-Z ]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        		add_name:x,
		   });
	    }
	}
	add_mobileChange(event)
	{
		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	add_mobile: x,
	        });
	    }
	}
	add_stateChange(event)
	{
		// this.setState({
		// 	add_state:event.target.value,
		// });
		var x=event.target.value;
		var invalidChars = /[^a-zA-Z]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        		add_state:x,
		
	        });
	    }
	}
	add_cityChange(event)
	{
		// this.setState({
		// 	add_city:event.target.value,
		// });
		var x=event.target.value;
		var invalidChars = /[^a-zA-Z]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        		add_city:x,
		    });
	    }
	}
	add_doornoChange(event)
	{
		this.setState({
			add_doorno:event.target.value,
		});
	}
	add_pincodeChange(event)
	{
		var x=event.target.value;
		var invalidChars = /[^0-9]/gi;
	    if(invalidChars.test(event.target.value)) {
	        x = event.target.value.replace(invalidChars,"");
	    }
	    else
	    {
	    	this.setState({
	        	add_pincode: x,
	        });
	    }
	}
	// ***********************************
	// setDefaultAddress function is used to set the default address when click on circle image in address block 
	// setDefaultAddress(add_id)
	// {
	// 	var baseUrl='https://aquadeals.in/admin/web3/user/';
	// 	var data1={from:'desktop_web',id:localStorage.user_id,token:localStorage.token,add_id:add_id,quick_buy:1};
	// 	var data2=JSON.stringify(data1);
	// 	$.ajax({
	// 		method:'POST',
	// 		dataType:'json',
	// 		data:{req:data2},
	// 		url:baseUrl+'setdefault_address',
	// 		success:function(data)
	// 		{
	// 			if(data.status==="success")
	// 			{
	// 				this.getUserAddress();
	// 			}
	// 		}.bind(this),
	// 		error:function(err)
	// 		{
	// 			console.log(err);
	// 		}
	// 	});
	// }
	//setPaymentMode is used to set the mode of the payment like 2 for - advance,3 for total,4 for other and calling the modeChange_cartCalculations
	//hiding the other amount input field and calling
	setPaymentMode(id)
	{
		this.setState({
			ptype:id,
			mode:id,
		});
		if(id===4)
		{
			this.setState({
				other_amount_field_status: true,
			});
		}
		else 
		{
			this.setState({
				other_amount_field_status: false,
			});
			this.modeChange_cartCalculations(id);
		}
	}
	validateOtherAmount()
	{
		this.setState({
			err_qty_status:false,
			err_qty_msg:'',
		});
		var x='';
		if(parseInt(this.refs.ref_other_amt.value,10) < parseInt(this.state.min_val,10))
		{
			x='Minimum Quantity is '+this.state.min_val;
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Minimum amount is '+this.state.min_val,
			});
		}
		if(parseInt(this.refs.ref_other_amt.value,10) > parseInt(this.state.max_val,10))
		{
			// alert('Maximum Quantity is '+this.state.max_qty);
			x='Maximum Quantity is '+this.state.max_val;
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Maximum amount is '+this.state.max_val,
			});
		}
		const check= /[^0-9]/gi;
		if(check.test(this.refs.ref_other_amt.value))
		{
			x='* Invalid Amount';	
			this.setState({
				err_qty_status: true,
				err_qty_msg:'* Invalid Amount',
			});
		}

		// this.other_amount_cartCalculations(4,this.refs.ref_other_amt.value);

		if(x==='')
		{
			this.other_amount_cartCalculations(4,this.refs.ref_other_amt.value);	
		}
	}
	handleTabsSelect(key)
	{
		this.setState({
			evnt_key:key,
		});
		this.modeChange_cartCalculations(key);
	}
	// functions for "ADD" form validations and updations END here 
	render(){
		document.title="Quick Buy Checkout | AquaDeals";
		var coupon_map = this.state.coupons.map(function(coupon,index){
			return(
				<span key={index} style={{display:'block'}}>{coupon.coupon_code} (&#8377;{coupon.value} )</span>
				);
		});
		const couponsList = (
				<Popover id="popover-positioned-top1">
					{coupon_map}
				</Popover>
		);
		var coupon_info=<OverlayTrigger trigger="focus" placement="top" overlay={couponsList}>
							<Button className="cartCoupon_info_img"><img src={baseAssets+'icons/web_icons/coupon_info.png'} alt=" " /></Button>
						</OverlayTrigger>;
		
		var promos_map=this.state.promos.map(function(promo,index){
			return(
				<span key={index} style={{display:'block'}}>{promo.promo_code} ( &#8377; {promo.promo_value} )</span>
				);
		});
		const promosList=<Popover id="popover-positioned-top2">
							{promos_map}
						 </Popover>;

		var promo_info='';
		promo_info=<OverlayTrigger trigger="focus" placement="top" overlay={promosList}>
						<Button className="cartCoupon_info_img"><img src={baseAssets+'icons/web_icons/coupon_info.png'} alt=" " /></Button>
					</OverlayTrigger>;		
		var Items = this.state.cart_items.map(function(item,index){
			return(
	             <div className="row cart_ItemsList">
					  <div className="row">
						 	
							<div className="col-sm-2 col-md-2 col-lg-2 webcart_centerimg">     
							     <Link to={item.type === 0 ? '/web/sdetails/'+item.url_name +'/'+item.deal_id : '/web/pdetails/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.url_brand_name+'/'+item.url_product_name+'/'+item.pid+'/'+item.deal_id} style={{clear:'both'}}>
									{item.type === 0 ? <img src={baseAssets+'icons/'+item.img} alt=" " /> : <img src={baseAssets+'images/product_imgs/thumbnails/'+item.img}  alt=" "  />}
							     </Link>
							</div> 
							<div className="cartdesc_Blk">
								<div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 cart_title_blk">
								    <Link to={item.type === 0 ? '/web/sdetails/'+item.url_name +'/'+item.deal_id : '/web/pdetails/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.url_brand_name+'/'+item.url_product_name+'/'+item.pid+'/'+item.deal_id} style={{clear:'both'}}>
								  	{item.pro_name !=="" ? <h3 className="cartitem_Title">{item.pro_name}</h3> : <h3 className="cartitem_Title">&nbsp;</h3>}
								    {item.brand ? <h4 className="cartitem_Brand">{item.brand}</h4>:<h4>&nbsp;</h4>} 
								   </Link>
								</div>
								<div className="col-md-2 col-lg-2 col-sm-2 text-right">
	                               <Link to={item.type === 0 ? '/web/sdetails/'+item.url_name +'/'+item.deal_id : '/web/pdetails/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.url_brand_name+'/'+item.url_product_name+'/'+item.pid+'/'+item.deal_id} style={{clear:'both'}}> 
	                                 {item.mrp !== '' ? <h3 className="webcart_mrp">&#8377;{item.mrp}</h3>:<h3>&nbsp;</h3>}
								   </Link>
								</div>	
								<div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 text-center">
								{/*	{item.min_qty !== "" ? <p onClick={()=>{this.updateMinQty(item.qty,item.min_qty,item.max_qty,item.id)}} className="webQty_Edit"><span>{item.qty}</span></p> :<p>&nbsp;</p>} */}
								    {item.min_qty !== "" ? <p className="webQty_Edit cart_edit ">{item.qty}</p> :<p>&nbsp;</p>}
								</div>
								<div className="col-xs-2 col-sm-2 col-md-2 col-lg-2" style={{paddingLeft:'0px',paddingRight:'0px'}}>   
								   <Link to={item.type === 0 ? '/web/sdetails/'+item.url_name +'/'+item.deal_id : '/web/pdetails/'+item.url_dtype_name+'/'+item.url_cat_name+'/'+item.url_brand_name+'/'+item.url_product_name+'/'+item.pid+'/'+item.deal_id} style={{clear:'both'}}>
									 {item.amount !== "" ? <p className="cartitem_amount cart_amt"><span>&#8377; </span><span>{item.amount}</span></p> :<p>&nbsp;</p>}
								   </Link>
								</div>
								<div className="col-lg-1 col-md-1 col-sm-1 col-xs-1">
								</div>
							</div>
						
					</div>
				 </div>  
			);
			
		  });
		  $('.mob_check').unbind("click").click( function(){
        	$(".mob_check img").attr("src","https://aquadeals.in/admin/assets/images/icons/circle_gray.png");        	
        	var sel_addr_id=$(this).attr("id");
        	var add_id =  sel_addr_id.replace('swipe-addr-id_','');
        	$("#"+sel_addr_id+" .mob_check img").attr("src","https://aquadeals.in/admin/assets/images/icons/ok.png");
		//$(".swipe_addr_blk .mob_check img").attr('src',"https://aquadeals.in/admin/assets/images/icons/circle_gray.png");
					if(localStorage.source)
			      {
			        var source=localStorage.getItem('source');
			      }
			      else
			      {
			        source='';
			      }
			      if(localStorage.campaign)
			      {
			        var campaign=localStorage.getItem('campaign');
			      }
			      else
			      {
			        campaign='';
			      }
			      if(localStorage.url_id)
			      {
			        var url_id=localStorage.getItem('url_id');
			      }
			      else
			      {
			        url_id='';
			      }
					var data1={from:'mobile_web',id:localStorage.user_id,token:localStorage.token,add_id:add_id,source:source,campaign:campaign,url_id:url_id};
					var data2=JSON.stringify(data1);
					$.ajax({
						method:'POST',
						dataType:'json',
						data:{req:data2},
						url:baseUrl+'setdefault_address',
						success:function(data)
						{
							if(data.status==="success")
							{
								//this.getUserAddress();
							}
						}.bind(this),
						error:function(err)
						{
							console.log(err);
						}
					});        		
        });
         
         var tabs_data='';
		// $('#off_modal_status').parent().addClass('offline_modal');
		if(this.state.paymentMethodStatus === 'Both')
		{
			tabs_data=<Tabs activeKey={this.state.evnt_key} className="web_pay_both" id="controlled-tab-ex" onSelect={this.handleTabsSelect}  >
	        		<Tab eventKey={2} title="ONLINE">
	        			<div>
			           		{this.state.prebook_payment===1 ? 
			           		<div className="group web_group">
			           			<label className={this.state.ptype === 2 ? 'pay_active' : 'pay_inactive'}>
			           				<input type="radio" name="pay_value" ref="pay_adv" checked={this.state.ptype === 2 ? true: false} onChange={()=>{this.setPaymentMode(2)}}  required/>
			           				Pay Advance &#8377; {this.state.pay_advance}	
			           			</label>
			           		</div> : ''}
			           		{this.state.otheramount_payment ===1?
			           		<div className="group web_group">
			           			<label className={this.state.ptype === 4 ? 'pay_active' : 'pay_inactive'}>
			           				<input type="radio" name="pay_value" ref="pay_other" checked={this.state.ptype === 4 ? true: false} onChange={()=>{this.setPaymentMode(4)}} required />
			           				Pay Other Advance {/*{this.state.pay_advance}	 */}
			           				{this.state.other_amount_field_status ? <span style={{marginLeft:'10px',position:'absolute'}}><input onBlur={()=>this.validateOtherAmount()} onChange={()=>this.validateOtherAmount()} ref="ref_other_amt" id="ref_other_amt" type="text" placeholder="Enter Amount" />{this.state.err_qty_status ? <span className="error_other_amt">{this.state.err_qty_msg}</span>: ''}</span> : ''}
			           			</label>
			           		</div> : ''}
			           		{this.state.fullamount_payment ===1 ? 
			           		 <div className="group web_group">
			           			<label className={this.state.ptype === 3 ? 'pay_active' : 'pay_inactive'}>
			           				<input type="radio" name="pay_value" ref="pay_total" checked={this.state.ptype === 3 ? true: false} onChange={()=>{this.setPaymentMode(3)}} required />
			           				Pay Total &#8377; {this.state.final_amt}
			           			</label>
			           		</div> : ''}
			           		{this.state.free_shipment ===1 ? <div className="web_ship_van"><i><img src={baseAssets+'icons/web_icons/shipping_van.png'} width="25px" alt=" " /></i> {this.state.free_shipment_msg}</div> : ''}
			           		{this.state.full_aquacash_back_title ? <div><i><img src={baseAssets+'icons/web_icons/newcashback.png'} alt="" width="20px" /> </i> {this.state.full_aquacash_back_title}</div> : ''}
			           	</div>
			        </Tab>
			        <Tab eventKey={1} title="OFFLINE">
			        	<div>
			       			{this.state.offline_payment===1 ? 
			       			<div className="group web_group">
								<label className={this.state.ptype === 1 ? 'pay_active' : 'pay_inactive'} >
			       					<input type="radio" name="pay_value" ref="pay_outlet" checked={this.state.ptype === 1 ? true: false} onChange={()=>{this.setPaymentMode(1)}} required />
			           				Pay at Outlet &#8377; {this.state.final_amt}
			       				</label>
			       				{this.state.free_shipment ===1 ? <div className="web_ship_van"><i><img src={baseAssets+'icons/web_icons/shipping_van.png'} width="25px" alt=" " /></i> {this.state.free_shipment_msg}</div> : ''}
			       				{this.state.full_aquacash_back_title ? <div><i><img src={baseAssets+'icons/web_icons/newcashback.png'} alt="" width="20px" /> </i> {this.state.full_aquacash_back_title}</div> : ''}
			       			</div> : ''}
		           		</div>
		           	</Tab>
			    </Tabs>
		}
		else if(this.state.paymentMethodStatus==='Online')
		{
			tabs_data=<Tabs activeKey={this.state.evnt_key} className="pay_online" id="controlled-tab-ex" onSelect={this.handleTabsSelect}  >
	        		<Tab eventKey={2} title="ONLINE">
	        			<div>
			           		{this.state.prebook_payment===1 ? 
			           		<div className="group">
			           			<label className={this.state.ptype === 2 ? 'pay_active' : 'pay_inactive'}>
			           				<input type="radio" name="pay_value" ref="pay_adv" checked={this.state.ptype === 2 ? true: false} onChange={()=>{this.setPaymentMode(2)}}  required/>
			           				Pay Advance &#8377; {this.state.pay_advance}	
			           			</label>
			           		</div> : ''}
			           		{this.state.otheramount_payment ===1?
			           		<div className="group">
			           			<label className={this.state.ptype === 4 ? 'pay_active' : 'pay_inactive'}>
			           				<input type="radio" name="pay_value" ref="pay_other" checked={this.state.ptype === 4 ? true: false} onChange={()=>{this.setPaymentMode(4)}} required />
			           				Pay Other Advance {/*{this.state.pay_advance}	 */}
			           				{this.state.other_amount_field_status ? <span style={{marginLeft:'10px',position:'absolute'}}><input onChange={()=>this.validateOtherAmount()} onBlur={()=>this.validateOtherAmount()} ref="ref_other_amt" id="ref_other_amt" type="text" placeholder="Enter Amount" />{this.state.err_qty_status ? <span className="error_other_amt">{this.state.err_qty_msg}</span>: ''}</span> : ''}
			           			</label>
			           		</div> : ''}
			           		{this.state.fullamount_payment ===1 ? 
			           		 <div className="group">
			           			<label className={this.state.ptype === 3 ? 'pay_active' : 'pay_inactive'}>
			           				<input type="radio" name="pay_value" ref="pay_total" checked={this.state.ptype === 3 ? true: false} onChange={()=>{this.setPaymentMode(3)}} required />
			           				Pay Total &#8377; {this.state.final_amt}
			           			</label>
			           		</div> : ''}
			           		{this.state.free_shipment ===1 ? <div className="web_ship_van"><i><img src={baseAssets+'icons/web_icons/shipping_van.png'} width="25px" alt=" " /></i> {this.state.free_shipment_msg}</div> : ''}
			           		{this.state.full_aquacash_back_title ? <div><i><img src={baseAssets+'icons/web_icons/newcashback.png'} alt="" width="20px" /> </i> {this.state.full_aquacash_back_title}</div> : ''}
			           	</div>
			        </Tab>
			        {this.state.offline_payment===1 ?
			        <Tab eventKey={1} title="OFFLINE">
			        	<div>
			       			{this.state.offline_payment===1 ? 
			       			<div className="group">
								<label className={this.state.ptype === 1 ? 'pay_active' : 'pay_inactive'} >
			       					<input type="radio" name="pay_value" ref="pay_outlet" checked={this.state.ptype === 1 ? true: false} onChange={()=>{this.setPaymentMode(1)}} required />
			           				Pay at Outlet &#8377; {this.state.final_amt}
			       				</label>
			       				{this.state.free_shipment ===1 ? <div className="web_ship_van"><i><img src={baseAssets+'icons/web_icons/shipping_van.png'} width="25px" alt=" " /></i> {this.state.free_shipment_msg}</div> : ''}
			       				{this.state.full_aquacash_back_title ? <div><i><img src={baseAssets+'icons/web_icons/newcashback.png'} alt="" width="20px" /> </i> {this.state.full_aquacash_back_title}</div> : ''}
			       			</div> : ''}
		           		</div>
		           	</Tab> : ''}
			    </Tabs>
		}
		else if(this.state.paymentMethodStatus==='Offline')
		{
			tabs_data=<Tabs activeKey={1} className="pay_offline" id="controlled-tab-ex" >
	        {/*tabs_data=<Tabs activeKey={1} className="pay_offline" id="controlled-tab-ex" onSelect={this.handleTabsSelect}  > */}
	        		{this.state.offline_payment===1 ?
			        <Tab eventKey={1} title="OFFLINE">
			        	<div>
			       			{this.state.offline_payment===1 ? 
			       			<div className="group">
								<label className={this.state.ptype === 1 ? 'pay_active' : 'pay_inactive'} >
			       					<input type="radio" name="pay_value" ref="pay_outlet" checked={this.state.ptype === 1 ? true: false} onChange={()=>{this.setPaymentMode(1)}} required />
			           				Pay at Outlet &#8377; {this.state.final_amt}
			       				</label>
			       				{this.state.free_shipment ===1 ? <div className="web_ship_van"><i><img src={baseAssets+'icons/web_icons/shipping_van.png'} width="25px" alt=" " /></i> {this.state.free_shipment_msg}</div> : ''}
			       				{this.state.full_aquacash_back_title ? <div><i><img src={baseAssets+'icons/web_icons/newcashback.png'} alt="" width="20px" /> </i> {this.state.full_aquacash_back_title}</div> : ''}
			       			</div> : ''}
		           		</div>
		           	</Tab> : ''}
			    </Tabs>
		}
		else if(this.state.paymentMethodStatus==='None')
		{
			tabs_data=<Tabs activeKey={this.state.evnt_key} id="controlled-tab-ex" onSelect={this.handleTabsSelect} className="pay_partner"  >
	        <Tab eventKey={2} title="ONLINE" >
	        	<div>
	           		{this.state.prebook_payment===1 ? 
	           		<div className="group">
	           			<label className={this.state.ptype === 2 ? 'pay_active' : 'pay_inactive'}>
	           				<input type="radio" name="pay_value" ref="pay_adv" checked={this.state.ptype === 2 ? true: false} onChange={()=>{this.setPaymentMode(2)}}  required/>
	           				Pay Advance &#8377; {this.state.pay_advance}	
	           			</label>
	           		</div> : ''}
	           		{this.state.otheramount_payment ===1?
	           		<div className="group">
	           			<label className={this.state.ptype === 4 ? 'pay_active' : 'pay_inactive'}>
	           				<input type="radio" name="pay_value" ref="pay_other" checked={this.state.ptype === 4 ? true: false} onChange={()=>{this.setPaymentMode(4)}} required />
	           				Pay Other Advance {/*{this.state.pay_advance}	 */}
	           				{this.state.other_amount_field_status ? <span style={{marginLeft:'10px',position:'absolute'}}><input onBlur={()=>this.validateOtherAmount()} onChange={()=>this.validateOtherAmount()} ref="ref_other_amt" id="ref_other_amt" type="text" placeholder="Enter Amount" />{this.state.err_qty_status ? <span className="error_other_amt">{this.state.err_qty_msg}</span>: ''}</span> : ''}
	           			</label>
	           		</div> : ''}
	           		{this.state.fullamount_payment ===1 ? 
	           		 <div className="group">
	           			<label className={this.state.ptype === 3 ? 'pay_active' : 'pay_inactive'}>
	           				<input type="radio" name="pay_value" ref="pay_total" checked={this.state.ptype === 3 ? true: false} onChange={()=>{this.setPaymentMode(3)}} required />
	           				Pay Total &#8377; {this.state.final_amt}
	           			</label>
	           		</div> : ''}
	           		{this.state.free_shipment ===1 ? <div className="web_ship_van"><i><img src={baseAssets+'icons/web_icons/shipping_van.png'} width="25px" alt=" " /></i> {this.state.free_shipment_msg}</div> : ''}
	           		{this.state.full_aquacash_back_title ? <div><i><img src={baseAssets+'icons/web_icons/newcashback.png'} alt="" width="20px" /> </i> {this.state.full_aquacash_back_title}</div> : ''}
	           	</div>
	        </Tab>
	        {this.state.offline_payment===1 ?
	        <Tab eventKey={1} title="OFFLINE">
	        	<div>
	       			{this.state.offline_payment===1 ? 
	       			<div className="group">
						<label className={this.state.ptype === 1 ? 'pay_active' : 'pay_inactive'} >
	       					<input type="radio" name="pay_value" ref="pay_outlet" checked={this.state.ptype === 1 ? true: false} onChange={()=>{this.setPaymentMode(1)}} required />
	           				Pay at Outlet &#8377; {this.state.final_amt}
	       				</label>
	       				{this.state.free_shipment===1 ? <div className="web_ship_van"><i><img src={baseAssets+'icons/web_icons/shipping_van.png'} alt="" width="25px" /></i> {this.state.free_shipment_msg}</div> : ''}
	       				{this.state.full_aquacash_back_title ? <div><i><img src={baseAssets+'icons/web_icons/newcashback.png'} alt="" width="20px" /> </i> {this.state.full_aquacash_back_title}</div> : ''}
	       			</div> : ''}
           		</div>
           	</Tab> : ''}
	    	</Tabs>
		}

				// edit form empty errors when click on the text input fields starts here
		$('#edit_name').keyup(function(){
            $('#edit_name_err').text('');
  		});
  		$('#edit_mobile').keyup(function(){
            $('#edit_mobile_err').text('');
  		});
  		$('#edit_state').keyup(function(){
            $('#edit_state_err').text('');
  		});
  		$('#edit_city').keyup(function(){
            $('#edit_city_err').text('');
  		});
  		$('#edit_doorno').keyup(function(){
            $('#edit_doorno_err').text('');
  		});
		$('#edit_pincode').keyup(function(){
            $('#edit_pincode_err').text('');
  		});
 		// edit form validations ends here

		// add form removing error msg's when click on input fields start here
  		$('#add_name').keyup(function(){
            $('#add_name_err').text('');
  		});
  		$('#add_mobile').keyup(function(){
            $('#add_mobile_err').text('');
  		});
  		$('#add_state').keyup(function(){
            $('#add_state_err').text('');
  		});
  		$('#add_city').keyup(function(){
            $('#add_city_err').text('');
  		});
  		$('#add_doorno').keyup(function(){
            $('#add_doorno_err').text('');
  		});
		$('#add_pincode').keyup(function(){
            $('#add_pincode_err').text('');
  		});
		const params = {
	      paginationClickable: true,
	      spaceBetween: 30,
	      slidesPerView: 2.2,
	      navigation: {
		        nextEl: '.swiper-button-next',
		        prevEl: '.swiper-button-prev'
		    },

   		}
		
		var delivery_address=this.state.user_address.map(function(data,index){
			return(
					localStorage.address_change_flag==='0' ? 
						<Col md={8} xs={8} className="swipe_addr_blk" id={"swipe-addr-id_"+data.add_id}>
							<Col md={2} sm={2} xs={2} className="mob_check" id={"swipe-addr-id_"+data.add_id}>
								<img src={data.default==='1' ? baseAssets+'images/icons/ok.png' : baseAssets+'images/icons/circle_gray.png'} alt="" />
							</Col>
							<div style={{margin: '0 20px'}}>
							<Col md={8} sm={8} xs={8} className="s_data_blk">
								<p>{data.name}&nbsp;</p>
								<p>{data.mobile}&nbsp;</p>
								<p>{data.state}&nbsp;</p>
								<p>{data.city}&nbsp;</p>
								<p>{data.address}&nbsp;</p>
								<p>{data.zip}&nbsp;</p>
							</Col>
							</div>
							<Col md={12} sm={12} xs={12} style={{paddingLeft:'0px',paddingRight:'0px'}}>						
							<ul className="addr_btns">
								// <li onClick={()=>{this.editAddress(data.add_id)}}>EDIT</li>
								// <li onClick={()=>this.deleteAddress(data.add_id)}>DELETE</li>
								<div>&nbsp;</div>
								<div>&nbsp;</div>
							</ul>
							</Col>						
						</Col>						
						:
						<Col md={8} xs={8} className="swipe_addr_blk" id={"swipe-addr-id_"+data.add_id}>
						<Col md={2} sm={2} xs={2} className="mob_check" id={"swipe-addr-id_"+data.add_id}>
							<img src={data.default==='1' ? baseAssets+'images/icons/ok.png' : baseAssets+'images/icons/circle_gray.png'} alt="" />
						</Col>
						<div style={{margin: '0 20px'}}>
						<Col md={8} sm={8} xs={8} className="s_data_blk">
							<p>{data.name}&nbsp;</p>
							<p>{data.mobile}&nbsp;</p>
							<p>{data.state}&nbsp;</p>
							<p>{data.city}&nbsp;</p>
							<p>{data.address}&nbsp;</p>
							<p>{data.zip}&nbsp;</p>
						</Col>
						</div>
						{/*<Col md={1} sm={1} xs={1} className="s_actions_blk img_wth_mob" id={"swipe-addr-id_"+data.add_id}>
							<div onClick={()=>{this.editAddress(data.add_id)}}><i><img src={baseAssets+'images/icons/edit_address.png'} alt="" /></i></div>
							<div style={{position:'absolute',top:'89px'}} onClick={()=>this.deleteAddress(data.add_id)}><i><img src={baseAssets+'images/icons/del_bin.png'} alt="" /></i></div>
						</Col>*/}
						<Col md={12} sm={12} xs={12} style={{paddingLeft:'0px',paddingRight:'0px'}}>						
						<ul className="addr_btns">
							<li onClick={()=>{this.editAddress(data.add_id)}}>EDIT</li>
							<li onClick={()=>this.deleteAddress(data.add_id)}>DELETE</li>
						</ul>
						</Col>						
					</Col>
			);
		}.bind(this));


		var offline_success =<section className="offline_success_data">
								<Modal.Header className="offline_header_section">
						    		<div className="" >
							      		<h5><Link to={"/web/home"}><i style={{marginRight:'15px'}}><img src={'https://aquadeals.in/admin/assets/icons/web_icons/close_icon1.png'} width="16px" alt=""/></i></Link>Confirmation</h5>
								       	<a href="/web/home" className="web_home_icon"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/home2.png'} alt="Home" /></a>
								    </div>
								</Modal.Header>
								<div style={{textAlign:'center',paddingBottom:'10px'}}>
					  			<i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png'} alt="AquaDeals" width="100px" /></i>
					  			<h5 style={{color:'green'}}>{this.state.offline_confirm_data.success_msg}</h5>
					  			<h6 style={{color:'#ff742a'}}>{this.state.offline_confirm_data.thank_msg}</h6>
					  		</div>
					  		<div className="modal_ordr_dtls_blk">
					  			<div className="web_modal_ordr_dtls">
					  				<h5>Order Details</h5>
					  			</div>
						  		<div className="" style={{padding:'10px'}}>
						  			<h5><span>SELLER NAME : </span><span>{this.state.offline_confirm_data.address ? this.state.offline_confirm_data.address.seller_name : ''}</span></h5>
						  			<h5><span>ORDER NO</span><span style={{float:'right'}}>ORDER DATE</span></h5>
						  			<h5><span>{this.state.offline_confirm_data.book_id}</span><span style={{float:'right'}}>{this.state.offline_confirm_data.booking_date ? this.state.offline_confirm_data.booking_date : ''}</span></h5>
						  		</div>
						  	</div>
						  	<div className="modal_pro_details_blk">
						  		<div className="web_modal_pro_title">
						  			<h5>Product Details </h5>
						  		</div>
						  		<div style={{padding:'10px'}}> 
						  			<p><span>Item : {this.state.offline_confirm_data.qty ? this.state.offline_confirm_data.qty : ''}</span><span style={{float:'right'}}>Total : {this.state.offline_confirm_data.remaining_amount ? this.state.offline_confirm_data.remaining_amount : ''}</span></p>
						  		</div>
						  	</div>
						  	<div className="" style={{backgroundColor:'#fff',overflow:'hidden',paddingBottom:'10px',marginTop:'10px'}}>
				  				{this.state.offline_confirm_data.order_items ? this.state.offline_confirm_data.order_items.map(function(data,index){
				  			return(
				  				<div className="col-xs-12 col-md-12" style={{padding:'0px',paddingTop:'15px',paddingBottom:'15px',borderTop:'1px solid #eee'}}>
									<div className="col-xs-3 col-md-3">
										<img src={'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/20170323130243537436.jpg'} alt=" " />
									</div>
									<div className="col-xs-6 col-md-6" style={{padding:'0px'}}>
										<p>{data.pro_name} {data.unit}</p>
										<p>QTY : {data.quantity}</p>
									</div>
									<div className="col-xs-3 col-md-3" style={{padding:'0px'}}>
										<p style={{marginTop:'17px'}}>&#8377; {data.deal_amt}</p>
									</div>
								</div>)}) : ''}
						  	</div>
						  	<div>
						  		<div style={{backgroundColor:'#f1f1f2',padding:'5px 0px 5px 10px'}}>
						  			<h5>PAYMENT DETAILS</h5>
						  		</div>
						  		<div style={{backgroundColor:'#fff',padding:'10px'}}>
						  			<h5><span>{this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].title : ''}</span><span style={{float:'right'}}>&#8377; {this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].value : ''}</span></h5>
						  		</div>
						  	</div>
						  	<div>
						  		<div className="" style={{backgroundColor:'#f1f1f2',padding:'5px 0px 5px 10px'}}>
						  			<h5>SHIPPING ADDRESS</h5>
						  		</div>
								<div className="" style={{backgroundColor:'#fff',padding:'10px'}}>
									<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].name : ''}</p>
									<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].address : ''} , {this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].city : ''} </p>
									<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].state : ''}</p>
									<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].phone : ''}</p>
									<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].zip : ''}</p>
								</div>
						  	</div>
						  	{/*<div style={{textAlign:'center',marginTop:'100px'}} className="modal_share_blk">
						  		<div>
						  			<Link style={{color:'#ff742a'}} to={'/share_earn'}><img src="https://aquadeals.in/admin/assets/images/icons/nav_refer_earn.png" width="40px" alt="" />Share & Earn</Link>
						  		</div>
						  	</div> */}
						</section>;
		return(
			<div className="web_deals web_quick_checkout_page">
				<WebHeaderInner />
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				<div className="clr">&nbsp;</div>
				 <div className='container'>
				   <Breadcrumb className="webcheckout_breadcrumb">
			         <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
			         <Breadcrumb.Item active>Quick Checkout</Breadcrumb.Item>
		           </Breadcrumb>
				</div>
				<section className="container">
					{this.state.offline_success ? <div className="col-md-12 web_dels_cntnt">{offline_success}</div>
				 	 :
					  <div className="col-md-12 col-lg-12 col-sm-12 web_dels_cntnt">
							{this.state.page_loading ? 
							<div>
								{parseInt(this.state.cart_count,10) > 0 ?
									<div className="body_content">
									 	{this.state.paying_process ? <div className="web_checkout_loading"><img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading"  />
									</div>
				 				:
				 				<div>
				 				   <div className="row">
				 				     <div className="container">
									  <section id="cart-process">                
										<div className="progressbar-wrapper" style={{background:'unset!important'}}>
										      <ul className="progressbar">
										          <li className="active">
										            <div>Cart</div>
										            <div><Icon
										                    name='check'
										                    font='Entypo'
										                    color='#fff'
										                    size={14}
										                    // style={{}}
										                  />
										            </div>
										          </li>
										          <li>
										            <div>Checkout</div>
										            <div><Icon
										                    name='check'
										                    font='Entypo'
										                    color='#fff'
										                    size={14}
										                    // style={{}}
										                  />
										            </div>          
										          </li>
										          <li>Payment</li>
										      </ul>      
										</div>
									</section>				 			  										  
				 				      <div className="col-lg-3 col-md-3 col-sm-3">
				 				      	  <div className='web_chk_dlry_title_blk'>
		                                    <h4>ADD SHIPPING ADDRESS</h4>
							 		      </div>
				 				      	  <form className="web_add_address_form" onSubmit={this.handleSubmit_add}>
						  					<div className="web_add_form_blk">
							  					<input type="text" placeholder="Name" ref="add_name" id="add_name" value={this.state.add_name} onChange={this.add_nameChange} required />
							  					<p id="add_name_err"></p>
												<input type="text" maxLength={10} placeholder="Mobile" ref="add_mobile" id="add_mobile" value={this.state.add_mobile}  onChange={this.add_mobileChange} required />
							  					<p id="add_mobile_err"></p>
							  					<input type="text" placeholder="Enter State" ref="add_state" id="add_state" value={this.state.add_state} onChange={this.add_stateChange} required />
							  					<p id="add_state_err"></p>
							  					<input type="text" placeholder="Enter City/Town" ref="add_city" id="add_city" value={this.state.add_city} onChange={this.add_cityChange} required />
							  					<p id="add_city_err"></p>
							  					<input type="text" placeholder="Door No/Landmark" ref="add_doorno" id="add_doorno" value={this.state.add_doorno} onChange={this.add_doornoChange} required />
							  					<p id="add_doorno_err"></p>
							  					<input type="text" maxLength={6} placeholder="Pincode" ref="add_pincode" id="add_pincode" value={this.state.add_pincode} onChange={this.add_pincodeChange} required  />
												<p id="add_pincode_err"></p>
												<div className="clr">&nbsp;</div>
												<div className="text-right">
													<button type="submit" className="web_save_add_btn" value="ADD">ADD</button>
												</div>
						  					</div>
								  		  </form>
				 				      </div>
									  <div className="col-md-8 col-lg-8 col-sm-8">
									    <section className="web_chk_dlry_title_blk">
										 	<div id="pay_response">{this.state.response}</div>
										 	<h4>DELIVERY ADDRESS
										 	 {delivery_address.length > 0 ?
										 	  <div className="pro_sld_ctrls">
												<a className="left carousel-control pro_sld_lft" onClick={this.goPrev}>
										          <span className="pro_sld_arow"><img src={baseAssets+'images_web/left_arrow.png'} alt="" /></span>
										          <span className="sr-only"></span>
										        </a>
										        <a className="right carousel-control pro_sld_rgt" onClick={this.goNext}>
										          <span className="pro_sld_arow"><img src={baseAssets+'images_web/right_arrow.png'} alt="" /></span>
										          <span className="sr-only"></span>
										        </a>
									           </div>
									           :''}
									        </h4>
										 	<h5>{/*<span style={{float:'right',color:'#ff742a'}} onClick={()=>{this.setState({add_address:true,})}}>ADD NEW</span>*/}</h5>
									 	</section>
									 	
										<section className="web_chk_dlry_data_blk col-sm-12 col-md-12 col-lg-12">
										 	{this.state.click_here_status ? <div className="empty_add_blk"><a>Add Your shipping address</a></div>: 
											 	<Swiper {...params} key={delivery_address.length} ref={node => node ? this.swiper = node.swiper : ''}>
													{delivery_address}
												</Swiper>
										 	}
										</section>
									  </div>	
									</div>
									 <div className="clr">&nbsp;</div>
									 <div className="clr">&nbsp;</div>
									 <div className="clr">&nbsp;</div>
									 <div className="row">
									 	<div className="container">
										 <div className={this.state.payment_options == 0 ? "col-md-12 col-sm-12 col-lg-12" : "col-md-8 col-sm-8 col-lg-8"}>
									 		 {this.state.cart_items.length > 0 ?
									 		 	<section className="webChk_summary_Blk">
													<div className="row">
										                  <div className="col-md-4 col-lg-4 col-sm-4">
										                     <h4 className="add_Item">Added Item</h4>
										                  </div>
										                  <div className="col-md-2 col-lg-2 col-sm-2 text-right">
				  											 <h4>MRP</h4>			
										                  </div>
										                  <div className="col-md-3 col-lg-3 col-sm-3 text-center">
										                     <h4>Quantity</h4>
										                  </div>
										                  <div className="col-md-3 col-lg-3 col-sm-2">
										                     <h4>Price</h4>
										                  </div>
										            </div>
												 </section>
											  :''
									 		 }
									 		 <section className="webChk_Summary_Dtls_Blk">
												{/*<h5><span>{this.state.cart_count > 1 ? 'Items : '+ this.state.cart_count : 'Item : ' +this.state.cart_count }</span><span style={{float:'right'}}>You Pay : &#8377; {this.state.grand_total} </span></h5>*/}
											    {this.state.cart_count >0 ?  
											     <div className={this.state.cart_count > 3 ? 'scroll': ''}> 
												     {Items}
												 </div>
											     :''
											    } 
											    {this.state.cart_count >0 ?
											       <div className="row">
			                                          <div className="col-md-offset-5 col-md-7 col-lg-7 col-sm-7 col-sm-offset-5" style={{paddingLeft:0}}>
			                                             {/*<h4>Total:{this.state.total}</h4>
			                                             <h4>Aquacash Discount:{this.state.ac_discount}</h4>
			                                             <hr/>
			                                             <h4>Grand Total:{this.state.grand_total}</h4>*/}
			                                             <table className="table-responsive table webcheckout_table">
			                                                <tr>
			                                                   <td className="text-right">Total</td>
			                                                   <td>&#8377; {this.state.cart_total}</td>	
			                                                </tr>
			                                                 {/*<tr>
			                                                   <td className="text-right">Aquacash Discount</td>
			                                                   <td>{this.state.ac_discount ?<span>(-)&#8377;{this.state.ac_discount}</span>:''}</td>	
			                                                </tr>
			                                               */}
													{this.state.used_cash ? 
													<tr>
                                                   <td className="text-right">Aquacash Discount</td>
														<td>(-) &#8377; {this.state.used_cash}</td>
													</tr> : ''}           
													{this.state.coupons_amt1 ? 
											 	<tr>{this.state.coupons.length ===1 ? <td className="text-right">Applied Coupon <span className="appliedCoupon_Msg">: {this.state.coupons.length === 1 ? this.state.coupons[0]['coupon_code'] : ''}</span></td> : <td className="text-right">Coupons applied on your purchase {coupon_info}</td>}
												<td className="web_coupon_amt_tot">(-) &#8377; {this.state.coupons_amt}</td></tr> : '' }

													{this.state.coupon_amt!=0 ? 
											 	<tr>{this.state.coupon_code !="" ? <td className="text-right">Applied Coupon <span className="appliedCoupon_Msg">: {this.state.coupon_code}</span></td> : ''}
												<td className="web_coupon_amt_tot">(-) &#8377; {this.state.coupon_amt}</td></tr> : '' }																	                                               
			                                                <tr  style={{'borderTop':'1px solid #eee'}}>
			                                                   <td className="text-right">Grand Total</td>
			                                                   <td>&#8377; {this.state.grand_total}</td>	
			                                                </tr>
															<tr>
																<td colSpan={2} style={{'fontSize':'12px'}}>{parseHtml(this.state.deliver_date_text)}</td>
															</tr>			                                                
			                                             </table> 
			                                          </div>   
											       </div>
											      :
											      ''
											    }
								 			  </section>
									 		</div>
											{this.state.payment_options == 1 ?
											<div className="col-md-4 col-lg-4 col-sm-4">
									 			<section className="web_chk_pay_opts_blk">
													<h4>PAYMENT OPTIONS</h4>
												</section>
												{this.state.mode_loading ? 
													<div className="web_mode_loading">
														<img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading"  />
													</div>
												: tabs_data
												}
									 		</div>
								  : ''	                            
	                           }										 		
									 	  </div>
									 </div>
									 <div className="clr">&nbsp;</div>
									 <div className="clr">&nbsp;</div>
									 <div className="container">
									 	<div className="col-lg-12 col-md-12 col-sm-12 check_btm_btns">
									 		<div className="col-md-4 col-lg-4 col-sm-6">
			                           		   <Link to={'/web/customer_care'} className="enquire btn btn-default chck_enq_btn">ENQUIRE NOW</Link>
			                           		</div>
			                           		<div className="col-lg-4 col-md-4">&nbsp;</div>
			                           		<div className="col-lg-4 col-md-4 col-sm-6">
			                           		  {this.state.amount_loading? <Link className="pull-right btn btn-default pay">Loading..</Link> : <Link className="btn btn-default pull-right pay" onClick={()=>{this.payNow()}}>PAY NOW</Link>}
			                           		</div>
									 	</div>
									 </div>
									 <div className="clr">&nbsp;</div>
									 <div className="clr">&nbsp;</div>
								  </div>	
								  
									{/* Add Address Modal Form */}
									{/*<Modal className="m_pro_full_dtls_modal"  show={this.state.add_address} onHide={this.close}  >
										<Modal.Header closeButton>
								    		<Modal.Title className="m_title">Add Shipping Address</Modal.Title>
								  		</Modal.Header>
								  		<Modal.Body>
								  			<div>
								  				<form className="web_add_address_form" onSubmit={this.handleSubmit_add}>
								  					<div className="web_add_form_blk">
									  					<input type="text" placeholder="Name" ref="add_name" id="add_name" value={this.state.add_name} onChange={this.add_nameChange} required />
									  					<p id="add_name_err"></p>
														<input type="text" maxLength={10} placeholder="Mobile" ref="add_mobile" id="add_mobile" value={this.state.add_mobile}  onChange={this.add_mobileChange} required />
									  					<p id="add_mobile_err"></p>
									  					<input type="text" placeholder="Enter State" ref="add_state" id="add_state" value={this.state.add_state} onChange={this.add_stateChange} required />
									  					<p id="add_state_err"></p>
									  					<input type="text" placeholder="Enter City/Town" ref="add_city" id="add_city" value={this.state.add_city} onChange={this.add_cityChange} required />
									  					<p id="add_city_err"></p>
									  					<input type="text" placeholder="Door No/Landmark" ref="add_doorno" id="add_doorno" value={this.state.add_doorno} onChange={this.add_doornoChange} required />
									  					<p id="add_doorno_err"></p>
									  					<input type="text" maxLength={6} placeholder="Pincode" ref="add_pincode" id="add_pincode" value={this.state.add_pincode} onChange={this.add_pincodeChange} required  />
														<p id="add_pincode_err"></p>
														<div className="m_submit_blk">
															<button type="submit" className="save_add_btn" value="ADD">ADD</button>
														</div>
								  					</div>
								  				</form>
								  			</div>
								  		</Modal.Body>
								  	</Modal>*/}

								  	{/*Edit Address Form Modal */}
								  	<Modal onEntered={()=>{this.getAddressDetails()}}  className="" show={this.state.edit_address} onHide={this.close} >
										<Modal.Header closeButton>
								    		<Modal.Title className="m_title">Edit Shipping Address</Modal.Title>
								  		</Modal.Header>
								  		<Modal.Body>
								  			<div>
								  				<form className="web_edit_address_form" onSubmit={this.handleSubmit_edit}>
								  					<div className="web_edit_form_blk">
									  					<input type="text" id="edit_name" placeholder="Name" value={this.state.edit_name} onChange={this.edit_nameChange} ref="edit_name" required />
									  					<p id="edit_name_err"></p>
									  					<input type="text" placeholder="Mobile" maxLength={10} value={this.state.edit_mobile} onChange={this.edit_mobileChange} ref="edit_mobile" id="edit_mobile" required />
									  					<p id="edit_mobile_err"></p>
									  					<input type="text" placeholder="Enter State" value={this.state.edit_state} onChange={this.edit_stateChange} ref="edit_state" id="edit_state" required />
									  					<p id="edit_state_err"></p>
									  					<input type="text" placeholder="Enter City/Town" value={this.state.edit_city} onChange={this.edit_cityChange} ref="edit_city" id="edit_city" required />
									  					<p id="edit_city_err"></p>
									  					<input type="text" placeholder="Door No/Landmark" value={this.state.edit_doorno} onChange={this.edit_doornoChange} ref="edit_doorno" id="edit_doorno" required />
									  					<p id="edit_doorno_err"></p>
									  					<input type="text" placeholder="Pincode" maxLength={6} value={this.state.edit_pincode} onChange={this.edit_pincodeChange} ref="edit_pincode" id="edit_pincode"  required />
														<p id="edit_pincode_err"></p>
														<div className="m_submit_blk">
															<button type="submit" className="adrs_update_btn" value="UPDATE">UPDATE</button>
														</div>
								  					</div>
								  				</form>
								  			</div>
								  		</Modal.Body>
								  	</Modal>
									
								  {/* Modal for showing the offline Success confirmation details */}
									<Modal id="off_modal_status" className="off_modal_status" backdrop='static' show={this.state.offline_pay_success_status} onHide={this.testclose}  >
										<Modal.Header>
								    		<div className="" >
									      		<h5><Link to={"/web/home"}><i><img src={'https://aquadeals.in/admin/assets/mob-assets/arrow_back.png'} width="30px" alt=""/></i></Link>Confirmation</h5>
										       	<a href="/web/home" className="home_cartlogo"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/home1.png'} alt="" /></a>
										    </div>
										</Modal.Header>
								  		<Modal.Body>
									  		<div style={{textAlign:'center',paddingBottom:'10px'}}>
									  			<i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/cc_footer_icon.png'} alt="AquaDeals" width="100px" /></i>
									  			<h5 style={{color:'green'}}>{this.state.offline_confirm_data.success_msg}</h5>
									  			<h6 style={{color:'#ff742a'}}>{this.state.offline_confirm_data.thank_msg}</h6>
									  		</div>
									  		<div className="modal_ordr_dtls_blk">
									  			<div className="modal_ordr_dtls">
									  				<h5>Order Details</h5>
									  			</div>
										  		<div className="" style={{padding:'10px'}}>
										  			<h5><span>SELLER NAME : </span><span>{this.state.offline_confirm_data.address ? this.state.offline_confirm_data.address.seller_name : ''}</span></h5>
										  			<h5 style={{fontSize:'11px',marginTop:'4px',marginBottom:'4px'}}><span>ORDER NO</span><span style={{float:'right'}}>ORDER DATE</span></h5>
										  			<h5><span>{this.state.offline_confirm_data.book_id}</span><span style={{float:'right'}}>{this.state.offline_confirm_data.booking_date ? this.state.offline_confirm_data.booking_date : ''}</span></h5>
										  		</div>
										  	</div>
										  	<div className="modal_pro_details_blk">
										  		<div className="modal_pro_title">
										  			<h5>Product Details </h5>
										  		</div>
										  		<div style={{padding:'10px'}}> 
										  			<p><span>Item : {this.state.offline_confirm_data.qty ? this.state.offline_confirm_data.qty : ''}</span><span style={{float:'right'}}>Total : {this.state.offline_confirm_data.remaining_amount ? this.state.offline_confirm_data.remaining_amount : ''}</span></p>
										  		</div>
										  	</div>
										  	<div className="" style={{backgroundColor:'#fff',overflow:'hidden',paddingBottom:'10px',marginTop:'10px'}}>
								  				{this.state.offline_confirm_data.order_items ? this.state.offline_confirm_data.order_items.map(function(data,index){
								  			return(
								  				<div className="col-xs-12 col-md-12" style={{padding:'0px',paddingTop:'15px',paddingBottom:'15px',borderTop:'1px solid #eee'}}>
													<div className="col-xs-3 col-md-3">
														<img src={'https://aquadeals.in/admin/assets/images/product_imgs/thumbnails/20170323130243537436.jpg'} alt=" " />
													</div>
													<div className="col-xs-6 col-md-6" style={{padding:'0px'}}>
														<p>{data.pro_name} {data.unit}</p>
														<p>QTY : {data.quantity}</p>
													</div>
													<div className="col-xs-3 col-md-3" style={{padding:'0px'}}>
														<p style={{marginTop:'17px'}}>&#8377; {data.deal_amt}</p>
													</div>
												</div>)}) : ''}
										  	</div>
										  	<div>
										  		<div style={{backgroundColor:'#f1f1f2',padding:'5px 0px 5px 10px'}}>
										  			<h5>PAYMENT DETAILS</h5>
										  		</div>
										  		<div style={{backgroundColor:'#fff',padding:'10px'}}>
										  			<h5><span>{this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].title : ''}</span><span style={{float:'right'}}>&#8377; {this.state.offline_confirm_data.payment_details ? this.state.offline_confirm_data.payment_details[0].value : ''}</span></h5>
										  		</div>
										  	</div>
										  	<div>
										  		<div className="" style={{backgroundColor:'#f1f1f2',padding:'5px 0px 5px 10px'}}>
										  			<h5>SHIPPING ADDRESS</h5>
										  		</div>
												<div className="" style={{backgroundColor:'#fff',padding:'10px'}}>
													<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].name : ''}</p>
													<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].address : ''} , {this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].city : ''} </p>
													<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].state : ''}</p>
													<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].phone : ''}</p>
													<p>{this.state.offline_confirm_data.shipping_address ? this.state.offline_confirm_data.shipping_address[0].zip : ''}</p>
												</div>
										  	</div>
										  	<div style={{textAlign:'center',marginTop:'100px'}} className="modal_share_blk">
										  		<div>
										  			<Link style={{color:'#ff742a'}} to={'/share_earn'}><img src="https://aquadeals.in/admin/assets/images/icons/nav_refer_earn.png" width="40px" alt="" />Share & Earn</Link>
										  		</div>
										  	</div>
								  		</Modal.Body>
								  	</Modal>
								  	</div> }
								</div> :
								<div>
									<div className="web_cart_emtpy">
										<i><img src={'https://aquadeals.in/admin/assets/icons/web_icons/empty_cartbg.png'} alt="..." /></i>
										<h4>Your Quick Cart is Empty</h4>
										<Link to={"/web/home"} className="cart_shopbtn">SHOP NOW</Link>
									</div>
									{/*<div className="empty_checkout">Empty cart</div>*/}

									{/*<section className="web_botm_btns row" style={{paddingBottom:'5px'}}>
										<ul>	
											<li className="col-md-6 col-xs-6 col-sm-6" style={{cursor:'pointer'}}>
												<Link to={'/web/customer_care'}><i><img src={'https://aquadeals.in/admin/assets/images/icons/enquiry_now.png'} alt=" " /></i>Enquire Now</Link>
											</li>
											<li className="col-md-6 col-xs-6 col-sm-6" style={{cursor: 'pointer'}}>
												<Link to={'/web/home'}>Explore Deals</Link>
											</li>
										</ul>
									</section>*/}
									{/*<div className="container">
									 	<div className="col-lg-12 col-md-12 col-sm-12 check_btm_btns">
									 		<div className="col-md-4 col-lg-4 col-sm-6">
			                           		   <Link to={'/web/customer_care'}><i></i>Enquire Now</Link>
			                           		</div>
			                           		<div className="col-lg-4 col-md-4">&nbsp;</div>
			                           		<div className="col-lg-4 col-md-4 col-sm-6">
			                           		  <Link to={'/web/home'}>Explore Deals</Link>
			                           		</div>
									 	</div>
									</div>*/}
								</div>}
								 {/*<WebFooter /> */}
								</div> :  
								<div className="web_checkout_loading">{this.state.lod ? <div className="checkout_error_blk"><h4>Something went wrong</h4><Link to={'/web/home'} className="try_again_btn">Please try again!</Link></div> : <img src={'https://aquadeals.in/admin/assets/images/loading_more.gif'} alt="Loading"  />
								 }</div>}
							</div>
						}
						
					</section>
								<Modal className="invalid_order" show={this.state.order_error_modal} onHide={this.close}>
									<Modal.Body>
										{this.state.order_error_message}
										<a onClick={this.close} className="req_conf_ok_btn">OK</a>
							  		</Modal.Body>
							  	</Modal>						
					<WebFooter />
				</div>
			);
		}
	}


	function mapStateToProps(state){
		return {
			 rzp_keys: state.posts.rzp_keys
		}
	}
	export default connect(mapStateToProps,actions)(Web_Quick_Checkout);



/** WEBPACK FOOTER **
 ** ./src/Desktop/components/QuickCart/Web_Quick_Checkout.js
 **/